import Modal from '@mui/material/Modal';
import { HashLink } from 'react-router-hash-link';
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toggleModal } from "../../../reducers/modalReducer";
import { TEST_PAGE } from "../../../constants/routes";


const Banner = ({ data, isAnimationVisible, refs, calImage, }) => {
    const dispatch = useDispatch()
    const modal = useSelector((state) => state.modal);

    return (
        <div
            className="bg1 bpr brnr banner-bg"
            style={{
                backgroundImage: `url(${require('../../../../images/landingpage/form-background-3.png')})`,
                backgroundPosition: 'right top',
                backgroundSize: '100% 50%'
            }}
        >
            <div className="main-banner-container">
                <div className="pt1rem df fdc">
                    <div className="row df pr" style={{ flexWrap: "nowrap" }}>
                        {/* Left side block content block */}
                        <div className="col-sm df jcc fdc gg2rem" style={{ width: "70%", paddingRight: "100px" }}>
                            <div ref={refs?.current?.[0]} className={`fs1-75rem c15 tslp ${isAnimationVisible[0] ? 'op1 tty0' : 'op0 ttx20'}`} style={{ lineHeight: '50px' }}>
                                {/* Welcome to Diligentsia */}
                                {data?.['bannersubTitle']}
                            </div>
                            <div className='fw500 c15 mih12rem '>
                                <span className="c15 fs3-5rem" style={{ lineHeight: '70px' }}>
                                    {data?.['bannerTitle']}
                                </span>
                            </div>
                            {data?.['bannerDescription'] &&
                                <span className="fs1rem c15 tslp w100 xl-mt0rem">
                                    {data['bannerDescription']}
                                </span>
                            }
                        </div>
                        {/* Right side image block */}
                        <div className="col-sm mt2rem df jce pr right-img-area" style={{ width: '30%', height: '400px' }}>
                            <div className="pr">
                                <img src={data?.bannerImage} className={`zi1 pr person-img`} style={{ ...data?.imageStyle, height: '100%' }} />
                                {
                                    data?.videoButton ? <img src={data?.videoButton} onClick={() => dispatch(toggleModal({ open: "videoCompanies" }))} className={`zi1 pa cp pillIcon`} style={{ left: "54%", bottom: "33px", width: "172px !important", height: "50px" }} /> : null
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Calculator part */}
            {
                calImage && <div className="pr bg1 pb3rem mt4rem bsbb calcluter-sec cb">
                    <div className="bg1 p4rem mt2rem w100 df br45px bsbb" style={{ background: "radial-gradient(70% 70% at 24.51% 50.12%, #F5F7FF 0%, #E8ECFF 100%)" }}>

                        <div className='w30 df jcc'>
                            <img src={calImage} className="w90 ofcon" />
                        </div>

                        <div className='w70 df jcc fdc pl2rem pr2rem'>
                            {data?.gurantee?.point1 &&
                                <div className="fw400 fs1-75rem c15" style={{ lineHeight: '40px', }}>
                                    {data?.gurantee?.point1}
                                </div>
                            }
                            {data?.gurantee?.point2 &&
                                <div className="fw400 fs1-75rem c15" style={{ lineHeight: '40px', }}>
                                    {data?.gurantee?.point2}
                                </div>
                            }
                            {data?.gurantee?.point3 &&
                                <div className="fw400 fs1-75rem c15" style={{ lineHeight: '40px', }}>
                                    {data?.gurantee?.point3}
                                </div>
                            }
                            <div className='fw400 df jcs'>
                                {data?.gurantee?.['quickDemoBtn'] && <>
                                    <div className="pr df w100 jcfs mt2rem bottom-demo-btn">
                                        <Link to="/demoChecklist" className="cp bg4 bg3-hover td250 br40px df jcsb aic pl2rem pr2rem c1 tal" style={{ paddingTop: "10px", paddingBottom: "10px", width: '357px' }}>
                                            <div className="db">
                                                Quick Demo - Try It Now!
                                                <span className="c1 db w100 sm-p0rem" style={{ fontSize: "11px", lineHeight: "15px" }}>No registration required</span>
                                            </div>
                                            <svg width="20" height="17" viewBox="0 0 28 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M2.57843 14.5715H21.6274L15.8315 21.1082C14.1667 22.9858 16.6639 25.8021 18.3287 23.9245L23.6072 17.9621L27.1308 13.9818C27.8138 13.207 27.8138 11.9557 27.1308 11.1809L18.3287 1.24207C17.9938 0.853956 17.5329 0.636189 17.0526 0.640694C15.4672 0.640919 14.6892 2.8187 15.8315 4.05856L21.6411 10.5953H2.48727C0.0456802 10.7319 0.227984 14.7086 2.57843 14.5715Z" fill="white"></path>
                                            </svg>
                                        </Link>
                                    </div>
                                </>
                                }
                                {data?.['description']?.['isTestBtn'] &&
                                    <Link to={TEST_PAGE} className="bsbb jcc w400px bg1 tal df fdc aic fw500 mt1rem px1rem c1 bg4 br19px cp secend-sec-btn td250">
                                        <>FREE 2-Minute Test
                                            <span className='fw400 c21 df fdc' style={{ marginTop: '-2px', fontSize: '13px', lineHeight: '15px', fontStyle: 'italic' }}>No registration required</span>
                                            <i className="icon">
                                                <svg width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M1.39612 10.336H15.818L11.43 14.7241C10.1696 15.9845 12.0602 17.875 13.3206 16.6147L17.3169 12.6121L19.9847 9.94019C20.5017 9.42008 20.5017 8.58008 19.9847 8.05996L13.3206 1.38812C13.0671 1.12758 12.7181 0.981397 12.3545 0.984421C11.1542 0.984572 10.5652 2.4465 11.43 3.2788L15.8284 7.66688H1.32711C-0.521408 7.75859 -0.383387 10.4281 1.39612 10.336Z" fill="#FC7785" />
                                                </svg>
                                            </i>
                                        </>
                                    </Link>
                                }
                                {!data?.gurantee?.['quickDemoBtn'] && data?.['description']?.['isInvestorBtn'] &&
                                    <HashLink to="#investor-lookup" style={{ width: '333px', paddingLeft: '30px' }} className='bsbb jcc w400px bg1 tal df fdc aic fw500 mt1rem pt1rem px1rem c1 bg4 br19px cp secend-sec-btn td250'>
                                        <>Investor Database Check
                                            <i className="icon">
                                                <svg width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M1.39612 10.336H15.818L11.43 14.7241C10.1696 15.9845 12.0602 17.875 13.3206 16.6147L17.3169 12.6121L19.9847 9.94019C20.5017 9.42008 20.5017 8.58008 19.9847 8.05996L13.3206 1.38812C13.0671 1.12758 12.7181 0.981397 12.3545 0.984421C11.1542 0.984572 10.5652 2.4465 11.43 3.2788L15.8284 7.66688H1.32711C-0.521408 7.75859 -0.383387 10.4281 1.39612 10.336Z" fill="#FC7785" />
                                                </svg>
                                            </i>
                                        </>
                                    </HashLink>
                                }
                            </div>
                        </div>
                    </div>
                </div >
            }


            {/* Story Video Modal */}
            <Modal open={modal['open'] == 'videoCompanies'} onClose={() => dispatch(toggleModal({ open: '' }))} className='backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic'>
                <div className='bg1 shadow w100 p2-5rem bsbb df fdc m1rem maw900px br5px pr'>
                    <button className='close-popup' onClick={() => dispatch(toggleModal({ open: '' }))} >
                        <svg style={{ position: 'relative', top: '4px' }} className='pen fds h1rem f1 mr0-5rem' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 512' >
                            <path className='pen fa-primary' d='M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z' />
                        </svg>
                    </button>
                    <div style={{ position: 'relative', paddingBottom: '56.25%', height: '0' }}>
                        <iframe src={data.videoLink + "&output=embed"} frameborder="0" webkitallowfullscreen="true" mozallowfullscreen="true" allowFullScreen style={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '100%' }}></iframe>
                    </div>
                </div>
            </Modal>

        </div >
    )

}
export default Banner

